<template>
  <div>
    <div class="heading">{{ $t('commissioning.page_title') }}</div>
    <FilterProductButton :toggleWidth="'25%'" :valuesList="valuesList" />
    <NewGlassCard :title="translateFilterValue">
      <template v-slot:back-button>
        <v-btn class="back-button mb-6" @click="goOnePageBack()"
          ><v-icon color="#6E6E6E">mdi-arrow-left</v-icon></v-btn
        >
      </template>
      <CommissioningOverviewComponent />
    </NewGlassCard>
  </div>
</template>

<script>
import { NewGlassCard } from '@newnetzportal/netzportal-webapp-storybook-components';
import FilterProductButton from '../components/design-components/FilterProductButton';
import CommissioningOverviewComponent from '../components/commissioning-overview-component/CommissioningOverviewComponent.vue';
import { getCommissioningSummary } from '../services/CommissioningService';

export default {
  name: 'CommissioningPage',
  components: {
    CommissioningOverviewComponent,
    FilterProductButton,
    NewGlassCard,
  },
  created() {
    this.getCommissioningSummary();
  },
  data() {
    return {
      ordersSummary: {},
    };
  },
  computed: {
    journeyFilter() {
      return this.$store.getters.getJourneyFilter;
    },
    translateFilterValue() {
      switch (this.journeyFilter) {
        case 'electricity':
          return this.$t('commissioning.electricity_orders_filter');
        case 'gas':
          return this.$t('commissioning.gas_orders_filter');
        case 'water':
          return this.$t('commissioning.water_orders_filter');
        case 'all':
        default:
          return this.$t('commissioning.all_orders_filter');
      }
    },
    valuesList() {
      return [
        {
          label: this.$t('commissioning.all_orders_filter'),
          id: 'all',
          value: this.ordersSummary.count_orders,
        },
        {
          label: this.$t('commissioning.electricity_orders_filter'),
          id: 'electricity',
          value: this.ordersSummary.count_orders_electricity,
        },
        {
          label: this.$t('commissioning.gas_orders_filter'),
          id: 'gas',
          value: this.ordersSummary.count_orders_gas,
        },
        {
          label: this.$t('commissioning.water_orders_filter'),
          id: 'water',
          value: this.ordersSummary.count_orders_water,
        },
      ];
    },
  },
  methods: {
    goOnePageBack() {
      const previousPage = this.$store.getters.getPreviousPage;
      if (previousPage) {
        this.$router.push(previousPage);
      } else {
        this.$router.push('/');
      }
    },
    getCommissioningSummary() {
      getCommissioningSummary()
        .then((res) => {
          if (res) {
            this.ordersSummary = res;
          } else {
            this.ordersSummary = {};
          }
        })
        .catch((err) => {
          console.error('Error fetching commissioning summary:', err);
          this.ordersSummary = {};
        });
    },
  },
};
</script>

<style scoped>
.heading {
  font-size: 50px;
  margin-bottom: 0;
}
.back-button {
  border-radius: 40px;
  background-color: rgba(255, 255, 255, 0.9);
  height: 35px !important;
  width: 90px;
  box-shadow: none;
  margin-right: 30px;
}
</style>
